import { Box, Textarea, useTheme } from '@chakra-ui/react';
import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useSendTyping, useSendMessage } from '@outdoorly/react-chat-sdk';
import ResizeTextarea from 'react-textarea-autosize';
import { Store } from '../../store';
import { useIsDesktop } from '../../utils/dimensions';
import { useMemoizedFrame } from '../../utils/hooks';
import posthog from 'posthog-js';

type ChatBoxProps = {
  scrollToBottom: () => void;
  scrollToBottomIfClose: (scrollDiffAmount?: number) => void;
};

export const ChatBox: React.FC<ChatBoxProps> = (props) => {
  const { scrollToBottom, scrollToBottomIfClose } = props;
  const [message, setMessage] = useState('');
  const sendMessage = useSendMessage();
  const onMessageSend = () => {
    if (message && message.length) {
      sendMessage?.(message);
      setMessage('');
    }
  };
  const labels = Store.useState((s) => s.config.labels);
  const textAreaRef = useRef<null | HTMLTextAreaElement>(null);
  const isActivatorVisible = Store.useState((s) => s.activatorVisible);
  const isDesktop = useIsDesktop();
  const isMobile = !isDesktop;
  useEffect(() => {
    if (!isActivatorVisible && isDesktop) {
      textAreaRef.current?.focus();
    }
  }, [isActivatorVisible]);
  const typing = useSendTyping();

  const theme = useTheme();
  return (
    <Box
      p="9.5px 16px"
      backgroundColor="scheme.backgroundSecondary"
      borderRadius={isMobile ? 0 : '0 0 8px 8px'}
      boxShadow={`inset 0 1px 0 ${theme?.colors?.scheme?.borderPrimary}`}
    >
      <Textarea
        placeholder={labels.chatPlaceholder}
        variant="main-chat"
        minH="36px"
        overflow="hidden"
        w="100%"
        resize="none"
        autoFocus
        spellCheck
        ref={textAreaRef}
        as={ResizeTextarea}
        onHeightChange={() => {
          scrollToBottomIfClose(500);
        }}
        minRows={1}
        maxRows={5}
        overflowY="auto"
        inputMode="text"
        onChange={(e) => {
          void typing();
          setMessage(e.target.value);
        }}
        //@ts-ignore
        enterKeyHint="send"
        value={message}
        onKeyDown={(e) => {
          const eventTarget = e.target as EventTarget & { selectionStart: number };
          if (e.key === 'Enter' && (!e.shiftKey || eventTarget.selectionStart === 0)) {
            e.preventDefault();
            posthog.capture('SEND-MESSAGE');
            onMessageSend();
            scrollToBottom();
          }
        }}
      />
    </Box>
  );
};
